export default __webpack_public_path__ + "static/media/skiing.d460d6e4.jpg";